import React, { useState } from "react";
import { resetPassword } from "../services/users";
import "./ForgotPasswordPage.css";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      await resetPassword(email);
      setMessage(
        "Un'email con le istruzioni per il reset della password è stata inviata.",
      );
    } catch (error) {
      console.error("Errore durante il reset della password:", error);
      setMessage("Si è verificato un errore durante il reset della password.");
    }
  };

  return (
    <div className="forgotpassword-page page-wrapper">
      {message ? (
        <div className="forgotpassword-page-form page-content">
          <div className="forgotpassword-message">
            <p>{message}</p>
          </div>
        </div>
      ) : (
        <div className="forgotpassword-page-form page-content">
          <div className="forgotpassword-form">
            <form onSubmit={handleResetPassword}>
              <div>
                <label htmlFor="email">Email:</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit">Invia Email di Reset</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordPage;
